import { useEffect, useRef } from 'react';
import igv from 'igv';
import Box from '@mui/material/Box';

const IGVBrowser = ({ sample, cram, crai }) => {
  
    const igvContainerRef = useRef(null);
   
  useEffect(() => {

    let browser;
    
          const options = {
            genome: 'hg38', 
            locus: 'rs1799950',
            tracks:  [
              {
                name: sample,
                type: 'alignment',
                format: 'cram',
                url: cram,
                indexURL: crai,
                displayMode: "EXPANDED",
                color: '#E1BEE7', 
                colorBy: 'strand',
              },
              {
                name: 'clinvar db',
                type: 'variant',
                format: 'vcf',
                url: 'https://ftp.ncbi.nlm.nih.gov/pub/clinvar/vcf_GRCh38/clinvar.vcf.gz',
                indexURL: 'https://ftp.ncbi.nlm.nih.gov/pub/clinvar/vcf_GRCh38/clinvar.vcf.gz.tbi',
                displayMode: "EXPANDED",
                color: '#E1BEE7',
                colorBy: 'strand',
              },
            ]
          };

   
          igv.createBrowser(igvContainerRef.current, options)
          .then((b) => {
            browser = b;
            console.log('IGV browser initialized');
          })
          .catch((error) => {
            console.error('Error creating IGV browser:', error);
          });
    
          return () => {
            if (browser) {
              browser.removeAllTracks();
            }
          };
        }, []); // Only run once, on mount
  
  return ( 
    
        <Box ref={igvContainerRef} style={{ width: '100%', height: '600px',  }} />
      
    )};
  
  export default IGVBrowser;